require('./bootstrap');

window.Vue = require('vue');

Vue.component('modal', require('./shared/Modal.vue').default);
Vue.component('svg-icon', require('./shared/SvgIcon.vue').default);

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import VuePlyr from 'vue-plyr'
 
// The second argument is optional and sets the default config values for every player.
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: false }
  },
  emit: ['ended']
})

import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
Vue.component('AdvancedSearchForm', require('./components/guest/search/AdvancedSearchForm.vue').default);
Vue.component('SignUpOrSignInButton', require('./components/guest/login/SignUpOrSignInButton.vue').default);
Vue.component('SignUpForm', require('./components/guest/login/forms/SignUpForm.vue').default);
Vue.component('FinishAccountSetupForm', require('./components/guest/editor/FinishAccountSetupForm.vue').default);

Vue.component('SetAccountPasswordForm', require('./components/guest/user/SetAccountPasswordForm.vue').default); // User by both Editor and SubAgent

// Vue.component('FinishSubAgentAccountSetupForm', require('./components/guest/sub-agent/FinishSubAgentAccountSetupForm.vue').default); // DEPRECATED Sep 14, 2022. Do not delete! See docs/deprecations/SubAgentApplicationDeprecation.md for details

// NOTE: This components appear on the book page / front end when the Editor is logged in. However, to avoid loading a separate .js file, we use it from the guest.js file.
Vue.component('AddToFavouritesButton', require('./components/editor/front/AddToFavouritesButton.vue').default);
Vue.component('DeclineBookButton', require('./components/editor/front/DeclineBookButton.vue').default);
Vue.component('RatePlatformForm', require('./components/editor/shared/RatePlatformForm.vue').default);

Vue.component('CannotDownloadMaterialButton', require('./components/editor/front/CannotDownloadMaterialButton.vue').default);

// Subagent related components

// Vue.component('SubAgentApplicationForm', require('./components/guest/sub-agent-application/SubAgentApplicationForm.vue').default); // DEPRECATED Sep 14, 2022. Do not delete! See docs/deprecations/SubAgentApplicationDeprecation.md for details

const app = new Vue({
	el: '#app',
});
